import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const deleteProductFunc = createAsyncThunk(
    "deleteProduct",
    async (id, thunkAPI) => {
        try {
            const response = await api.delete(`dashboard/products/${id}`);
            return response.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
)

const deleteProductSlicer = createSlice({
    name: "deleteProduct",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(deleteProductFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(deleteProductFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";

            })
            .addCase(deleteProductFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
})

export default deleteProductSlicer.reducer;